export default __webpack_public_path__ + "static/7-bb97ccd59e0f2e6ad03d78195717ab35.png";